export default __webpack_public_path__ + "static/media/info.0b14b3e1.svg";